<template>
  <div class="relative w-full">
    <!-- Show video -->
    <div v-if="isYouTube(task.source.url)">
      <iframe
        :src="getYouTubeEmbedUrl(task.source.url)"
        class="h-52 w-full object-cover sm:h-72 sm:rounded-t-lg"
        :title="task.source.title"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <!-- Show source image -->
    <div v-else-if="task.source.image">
      <img :src="task.source.image" class="h-52 w-full object-cover sm:h-72 sm:rounded-t-lg" />
    </div>

    <!-- Show header only for non-YouTube -->
    <div
      v-if="!isYouTube(task.source.url)"
      class="bottom-0 w-full px-4 sm:px-8"
      :class="{
        'absolute bg-gradient-to-t from-white via-white/50 to-transparent pt-20 dark:from-gray-900 dark:via-gray-900/80': task.source.image,
        'pt-4': !task.source.image,
      }"
    >
      <div class="mt-1 flex items-center justify-between">
        <div class="mt-1 flex items-center">
          <div class="flex items-center space-x-2 divide-x">
            
            <div class="flex items-center">
              <!-- Icon -->
              <img v-if="task.source.publisher.icon" :src="task.source.publisher.icon" class="h-7 w-7 rounded object-cover" />
              <div class="flex" v-else-if="task.source.publisher.name || task.source.url">
                <div class="flex h-7 w-7 rounded-sm bg-red-500 text-sm text-white">
                  <p class="m-auto capitalize">
                    <span v-if="task.source.publisher.name">{{ task.source.publisher.name.charAt(0) }}</span>
                    <span v-else-if="task.source.url">{{ urlHostname(task.source.url).charAt(0) }}</span>
                  </p>
                </div>
              </div>

               <!-- Source, Title -->
              <div class="ml-2">
               
                <div class="flex items-center">
                  <span class="text-xs font-medium line-clamp-1 sm:line-clamp-2 dark:text-gray-100">
                    {{ task.source.title }}
                  </span>
                  <a :href="task.source.url" target="_blank" class="ml-1 text-xs underline">
                    <ExternalLinkIcon class="h-3 w-3" />
                  </a>
                </div>

                <!-- Source/Publisher -->
                <span v-if="task.source.publisher.name || task.source.url" class="text-xs tracking-wide text-gray-800 line-clamp-1 dark:text-gray-300">{{
                  task.source.publisher.name || urlHostname(task.source.publisher.url)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ExternalLinkIcon } from "@heroicons/vue/outline";
import utilFunctions from "../../composables/util";
export default {
  components: {
    ExternalLinkIcon,
  },
  setup() {
    const { urlHostname, getYouTubeEmbedUrl } = utilFunctions();

    function isYouTube(url) {
      if (url) {
        return url.includes("youtube.com") || url.includes("youtu.be") ? true : false;
      } else {
        return false;
      }
    }

    return {
      urlHostname,
      getYouTubeEmbedUrl,
      isYouTube,
    };
  },
  props: {
    task: Object,
  },
};
</script>
